export const VideoUrl = {
  fullDemo: 'https://www.youtube.com/embed/RizMpTFB1dw?rel=0&autoplay=1',
  QtoCreateReport: 'https://www.youtube.com/embed/qVuNhzkOX4M?rel=0&autoplay=1',
  QtoBreakdownManager: 'https://www.youtube.com/embed/dZ-XEaUskN8?rel=0&autoplay=1',
  QtoCustomFiltersTemplates: 'https://www.youtube.com/embed/6mJpe6WULdo?rel=0&autoplay=1',
  AutoMeasureMechanism2D: 'https://www.youtube.com/embed/Q2srAJkUK6Q?rel=0&autoplay=1',
  AnnotationsMechanism2D: 'https://www.youtube.com/embed/27JYCaV97oE?rel=0&autoplay=1',
  TemplatesMechanism2D: 'https://www.youtube.com/embed/Wb1P3EitU20?rel=0&autoplay=1',
};
